import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  ten_banner: undefined, // optional - Tên banner quảng cáo
  ngon_ngu: undefined, // required, enum(vi, en) - Mã ngôn ngữ
  vi_tri: undefined, // required Màn hình hiển thị. home - hiển thị ở màn hình home. login - hiển thị ở màn hình login
  anh_hien_thi: undefined, // required Ảnh quảng cáo hiển thị
  link_quang_cao: undefined, // required Đường dẫn quảng cáo
  hien_thi: undefined, // optional Cho phép hiển thị
  nguoi_tao: undefined, // required Id của người tạo quảng cáo
  thoi_diem_tao: undefined, // required Thời điểm tạo
  nguoi_sua: undefined, // optional Id của người sửa
  thoi_diem_sua: undefined, // required Thời điểm sửa cuối
  thu_tu: undefined, // optional Thứ tự hiển thị
};

// validation form
model.validForm = {
  ten_banner: [],
  ngon_ngu: [ValidService.requiredChange],
  vi_tri: [ValidService.requiredChange],
  anh_hien_thi: [ValidService.required],
  link_quang_cao: [ValidService.required, ValidService.checkLink],
  thu_tu: [ValidService.required],
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
  fileUploadOption: {
    AnhDaiDien: {
      limit: 1,
      accept: ".jpg, .png, .jpeg",
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
    },
  },
};

// validation các form khác
model.validFormOther = {};

model.listManHinh = [
  {
    id: "home",
    name: "Trang chủ",
  },
  {
    id: "login",
    name: "Đăng nhập",
  },
];

model.listHienThi = [
  {
    id: "true",
    name: "Hiển thị",
  },
  {
    id: "false",
    name: "Không hiển thị",
  },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["loai", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      vi_tri: "",
      hien_thi: "",
      ngon_ngu: "",
    },
    valid: {
      vi_tri: [],
      hien_thi: [],
      ngon_ngu: [],
    },
    operator: {
      hien_thi: "", //:regex:, $vn_text=Viêt nam
      vi_tri: "",
      ngon_ngu: "",
    },
  },
};

export default model;
